import Events from 'traits/events';
import { Entities } from 'system/entities';
import Listeners from 'system/listeners';
import str from 'type/str';
class AbstractElement {
    /********************
     * Instance Methods *
     ********************/
    constructor(element) {
        /**********************
         * Instance Variables *
         **********************/
        this._ID = '';
        this._listeners = [];
        this.events = new Events(this);
        this.subscriptions = [];
        this.attributes = {};
        this._ready = false;
        // get value(){
        //     return this.$element.val()
        // }
        this.bindings = {};
        this.UUID = str.uuid();
        this.element = element;
        this.$element = $(element);
        this.entity = Entities.get(element);
        this.entity.instance = this;
        //make sure element is registered to entity
        if (!this.entity.element)
            Entities.register(element);
        this.ID = this.entity.ID;
        // if(this.ID == 'homework-assignments') console.log(this.events.UUID)
        this.Element = this.entity.Element;
        this.observe();
        this.default = element.innerHTML;
        this.init();
    }
    set ID(ID) {
        this._ID = ID;
        this.events.ID = ID;
    }
    get ID() {
        return this._ID;
    }
    // set subscribe(subscription){
    //     this.subscriptions.push(subscription)
    // }
    get ready() {
        return this._ready;
    }
    set ready(value) {
        this._ready = value;
        this.entity.events.trigger('ready', this._ready);
    }
    get self() {
        return this;
    }
    set default(value) {
        this._default = value;
    }
    get default() {
        return this._default;
    }
    init() {
        //if this belongs to entities and is instantiated bind to instance
        Object.keys(this.entity.belongsTo).forEach(key => {
            const belongsTo = this.entity.belongsTo[key];
            if (belongsTo.instance)
                belongsTo.instance.bindEntity(this.entity);
        });
        //if entities belong to this and is instantiated bind to instance
        Object.keys(this.entity.has).forEach(key => {
            const has = this.entity.has[key];
            if (has.instance)
                this.bindEntity(has);
        });
        //Setup event listeners
        let events = _.get(this.entity.params, 'on', {});
        Object.keys(events).forEach(key => {
            let command = events[key];
            switch (key) {
                case 'input':
                case 'change':
                    //prevent early read of value on input change
                    this.events.on('change', (event) => {
                        var _a;
                        const result = new Function('self', 'target', 'entities', 'event', command)(this, (_a = this.forEntity()) === null || _a === void 0 ? void 0 : _a.instance, Entities, event);
                    }, this);
                    break;
                case 'changed': //prevent early read of value on input change
                case 'init':
                    this.events.on(key, (event) => {
                        var _a;
                        const result = new Function('self', 'target', 'entities', 'event', command)(this, (_a = this.forEntity()) === null || _a === void 0 ? void 0 : _a.instance, Entities, event);
                    }, this);
                    // if(this.ID == 'homework-assignments') console.log( 'init create', this.UUID, this.events.UUID )
                    break;
                default:
                    this.$element.on(key, (event) => {
                        var _a;
                        // console.log(key, event)
                        event.preventDefault();
                        const result = new Function('self', 'target', 'entities', 'event', command)(this, (_a = this.forEntity()) === null || _a === void 0 ? void 0 : _a.instance, Entities, event);
                    });
            }
        });
    }
    bind(instance, to) {
        const params = instance.entity.params;
        const from = _.get(params, 'bind.from', 'value');
        /**
         * Add to to bindings
         */
        _.set(this.bindings, [to, instance.ID], instance.entity);
        /**
         * Set this value equal to control if it has a value
         */
        const setFrom = _.get(instance, from);
        if (setFrom)
            _.set(this, to, setFrom);
        instance.events.on('change', () => {
            _.set(this, to, _.get(instance, from));
            // console.log("THIS", this, 'set to', to, _.get(instance, from))
        }, this);
        this.events.on('change', () => {
            _.set(instance, from, _.get(this, to));
            // console.log("INSTANCE", instance, 'set to', from, _.get(this, to))
        });
    }
    bindEntity(entity) {
        var _a;
        switch (entity.type) {
            case 'control':
            case 'controller':
            case 'canvas':
            case 'template':
            case 'module':
                (_a = entity.instance) === null || _a === void 0 ? void 0 : _a.bindTo(this);
                // console.log('bind', this, 'to', entity.instance)
                break;
        }
    }
    /**
     * Executed when another instance binds to this instance
     *
     * @param instance
     * @param init
     */
    bindTo(instance, init = true) {
        if (instance.ready)
            this.bindingReady(instance);
        /** BUG ** Adding duplicate on ready events to same entity object */
        const listeners = instance.entity.events.on('ready', () => {
            this.bindingReady(instance);
        }, instance);
        // console.log(this, ' bound to =>', instance)
        for (const listener of listeners)
            this._listeners.push(listener);
        const to = _.get(this.entity.params, 'bind.to');
        if (to)
            instance.bind(this, to);
    }
    /**
     * Runs after binding made and element.ready is true or when ready is set to true
     *
     * @param instance
     */
    bindingReady(instance) {
    }
    unbind(instance) {
    }
    hasEntities() {
        const entity = this.entity;
        if (entity === null || entity === void 0 ? void 0 : entity.has) {
            let entities = [];
            Object.keys(entity.has).some(key => {
                entities.push(entity.has[key]);
                return true;
            });
            if (entities)
                return entities;
        }
        return [];
    }
    forEntity() {
        const entity = this.entity;
        if (entity === null || entity === void 0 ? void 0 : entity.belongsTo) {
            let target = null;
            Object.keys(entity.belongsTo).some(key => {
                target = entity.belongsTo[key];
                return true;
            });
            if (target)
                return target;
        }
        return null;
    }
    //remove entity from associations
    disown(entityID) {
        const entity = Entities.get(entityID);
        const ID = entity.ID;
        //...... todo
    }
    observe() {
        this.Element.onRemove(event => { this.destruct(); });
        // this.Element.onLoad(()=>{this.loaded()})
    }
    loaded() {
        console.log('ELEMENT LOADED');
    }
    destruct() {
        /**
         * Remove event listeners registered to this instance
         */
        Listeners.destruct(this);
        // for(const listener of this.registeredListeners){
        //     // console.log(listener.event, listener.callback)
        //     // console.log('destructing', [listener.event, listener.identifier].filter(i=>i).join('.'))
        //     listener.element.removeEventListener([listener.event, listener.identifier].filter(i=>i).join('.'), listener.callback)
        //     // console.log([listener.event, listener.identifier].filter(i=>i).join('.'), listener.callback)
        // }
        /**
         * Remove event listeners connected created for this instance
         */
        this.events.complete();
        /**
         * Remove references to collection if any collections exists
         */
        if (this['collection']) {
            this['collection'].events.destruct();
            delete this['collection'];
        }
        /**
         * Remove references to this instance
         */
        // console.log('pre', this.entity.instance)
        delete this.entity.instance;
        delete this.entity['Element'];
        delete this.entity['element'];
        delete this.entity['$element'];
        if (this.element.hasAttribute('generated-id')) {
            this.entity.destruct();
        }
        // delete this['Events']
        // console.log('post', this.entity.instance)
        // console.log('deleted', this.entity)
        /**
         * Try to purge element from memory
         */
        this.$element.unbind();
        this.$element.remove();
        this.element.remove();
    }
    destroy(baseObject, refName) {
        delete baseObject[refName];
    }
    //Helper methods
    getParam(path = null, defaults = null) {
        if (path == null)
            return this.entity.params;
        return _.get(this.entity.params, path, defaults);
    }
}
export default AbstractElement;
export { AbstractElement };
